import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountShareAccessPoliciesFragment = { __typename?: 'Account', id: string, resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null };

export type WorkspaceShareAccessPoliciesFragment = { __typename?: 'Workspace', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null } | null } | null, resourceControlPolicies?: { __typename?: 'WorkspaceResourceControlPolicies', shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null, adminCanDisableInShares?: boolean | null, fullAccessCanDisableInShares?: boolean | null, editAndShareCanDisableInShares?: boolean | null } | null } | null };

export type ShareAccessPolicies_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisableSecureSharingInShares?: boolean | null } | null } | null };

export type ShareAccessPolicies_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisableSecureSharingInShares?: boolean | null } | null } | null };

export type ShareAccessPoliciesFragment = ShareAccessPolicies_AdHocAssetsShare_Fragment | ShareAccessPolicies_CollectionShare_Fragment;

export const AccountShareAccessPolicies = /*#__PURE__*/ gql`
    fragment AccountShareAccessPolicies on Account {
  id
  resourceControlPolicies {
    shareAccess {
      default
      minimum
      adminCanDisableInShares
      fullAccessCanDisableInShares
      editAndShareCanDisableInShares
    }
  }
}
    ` as unknown as DocumentNode<AccountShareAccessPoliciesFragment, unknown>;
export const WorkspaceShareAccessPolicies = /*#__PURE__*/ gql`
    fragment WorkspaceShareAccessPolicies on Workspace {
  id
  appliedResourceControlPolicies {
    shareAccess {
      default
      minimum
    }
  }
  resourceControlPolicies {
    shareAccess {
      default
      minimum
      adminCanDisableInShares
      fullAccessCanDisableInShares
      editAndShareCanDisableInShares
    }
  }
}
    ` as unknown as DocumentNode<WorkspaceShareAccessPoliciesFragment, unknown>;
export const ShareAccessPolicies = /*#__PURE__*/ gql`
    fragment ShareAccessPolicies on Share {
  id
  project {
    id
    appliedResourceControlPolicies {
      shareAccess {
        default
        minimum
      }
    }
    permissions {
      canDisableSecureSharingInShares
    }
  }
}
    ` as unknown as DocumentNode<ShareAccessPoliciesFragment, unknown>;

        

        
export const useAccountShareAccessPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<AccountShareAccessPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountShareAccessPoliciesFragment>({
    fragment: AccountShareAccessPolicies,
    fragmentName: 'AccountShareAccessPolicies',
    ...options,
  });
};
  
        
        

        
export const useWorkspaceShareAccessPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceShareAccessPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceShareAccessPoliciesFragment>({
    fragment: WorkspaceShareAccessPolicies,
    fragmentName: 'WorkspaceShareAccessPolicies',
    ...options,
  });
};
  
        
        

        
export const useShareAccessPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<ShareAccessPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareAccessPoliciesFragment>({
    fragment: ShareAccessPolicies,
    fragmentName: 'ShareAccessPolicies',
    ...options,
  });
};
  
        